// config.js
export const baseUrls = {
  kids: '/kids',
  parents: '/parents',
  organization: '/organization',
  teacher: '/teacher',
};

// export const WEB_URL = 'https://dreamsquad.hyperlinkdevteam.link/studentscholar/';
// export const WEB_URL = 'http://13.234.122.246/studentscholar/';
// export const WEB_URL = 'http://localhost:3000/studentscholar/';
// OLD CODE (kept as it is) :
// export const WEB_URL = 'https://studentscholars.com/';
// export const WEB_URL = 'http://localhost:3001/admin-redirect';

// The live web app is used by default. While the admin panel runs locally
// (npm start), the local web app is used instead so that flows which redirect
// to the web app - such as the Admin Login flow - can be tested end to end
// without having to edit this file before every deployment.
export const LIVE_WEB_URL = 'https://studentscholars.com/';
export const LOCAL_WEB_URL = 'http://localhost:3000/';

export const WEB_URL = process.env.NODE_ENV === 'development' ? LOCAL_WEB_URL : LIVE_WEB_URL;

export const PUBLIC_URL = process.env.PUBLIC_URL
